import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FikaIndexCardStackContentViewModel } from '../fika-index-card-stack-content-view-model';
import { PrintCardColumnViewModel } from '../../../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';

@Pipe({
  name: 'getSalePriceWasText',
  standalone: false
})
export class GetSalePriceWasTextPipe implements PipeTransform {
  transform(
    viewModel: FikaIndexCardStackContentViewModel,
    spoofedGridColVM: PrintCardColumnViewModel,
    nVariantsOnSale: number
  ): Observable<string | null> {
    return viewModel?.getSalePriceWasText$(spoofedGridColVM, nVariantsOnSale) || of(null);
  }
}
